export const environment = {
  production: false,
  baseUrl: "https://bazaid.midend.tech/api/"
};
